import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";

export default function BasicModal({
  isOpen,
  onClose,
  children,
  title,
  size = "6xl",
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={size} motionPreset="slideInBottom">
      <ModalOverlay bg="blackAlpha.400" backdropFilter="blur(2px)" />
      <ModalContent borderRadius="xl" mx={{ base: 4, md: "auto" }} my={{ base: 4, md: "auto" }}>
        <ModalHeader fontSize="lg" fontWeight="semibold" pr="14">
          {title}
        </ModalHeader>
        <ModalCloseButton borderRadius="md" />
        <ModalBody pb={6}>{children}</ModalBody>
      </ModalContent>
    </Modal>
  );
}
